import styled from "@emotion/styled";

import { fixedWidth } from "~/lib/client/design";

export const Container1200pxWidth = styled.div`
  ${fixedWidth("1200px")}
  margin: 0 auto;
`;
